<template>
  <page>
    <sidebar slot="sidebar"/>
    <span slot="header">Suggestions</span>
    <span slot="breadcrumbs">
      <b-breadcrumb :items="breadcrumbs"/>
    </span>
    <form-wrapper>
      <b-form-group>
        <label>Suggestion ID</label>
        <input
          :value="suggestion.id"
          disabled
          class="form-control"/>
      </b-form-group>
      <b-form-group>
        <label for="id">Text</label>
        <b-card>
          {{ suggestion.text }}
        </b-card>
      </b-form-group>
      <b-form-group v-if="suggestion.media && suggestion.media.length > 0">
        <label>Image</label>
        <div class="row">
          <div v-for="image in suggestion.media" 
               :key="image.id"
               class="col-sm-3">
            <image-preview
              :src="suggestionImageSrc(image)"
              @click.native="displayImage(image,true)"
            />
          </div>
        </div>
        
      </b-form-group>
      <b-form-group>
        <label>From</label>
        <b-card>
          <span class="name">{{ suggestion.user.name }}</span>
          <span>{{ suggestion.user.email }}</span>
          <b-badge v-if="!suggestion.user.is_active" variant="danger">Account Locked</b-badge>
          <b-badge v-if="!suggestion.user.is_confirmed" variant="danger">Not Confirmed</b-badge>
        </b-card>
      </b-form-group>
      <b-form-group v-if="suggestion.module || suggestion.component || suggestion.topic">
        <label>Relates To</label>
        <b-card>
          <div v-if="suggestion.module">
            Module:
            <router-link :to="{name: 'admin-components', params:{ module: suggestion.module.id }}" class="underline">
              {{ suggestion.module.name }}
            </router-link>
          </div>
          <div v-if="suggestion.module && suggestion.component">
            Component:
            <router-link :to="{name: 'admin-topics', params:{ module: suggestion.module.id, component: suggestion.component.id }}" class="underline">
              {{ suggestion.component.name }}
            </router-link>
          </div>
          <div v-if="suggestion.module && suggestion.component && suggestion.topic">
            Topic:
            <router-link :to="{name: 'admin-items', params:{ module: suggestion.module.id, component: suggestion.component.id, topic: suggestion.topic.id }}" class="underline">
              {{ suggestion.topic.name }}
            </router-link>
          </div>
        </b-card>
      </b-form-group>
      <b-form-group>
        <label>Sent</label>
        <b-card>
          {{ readableDate(toUnixTime(suggestion.created_at.date)) }}
        </b-card>
      </b-form-group>
    </form-wrapper>
  </page>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import formWrapper from '../../../common/form/form-wrapper'
import imagePreview from '../../../common/image-preview'
import page from '../../../templates/page'
import sidebar from '../../../sidebar'
import { readableDate } from '../../../../helpers'

export default {
  components: {
    imagePreview,
    page,
    sidebar,
    formWrapper
  },
  data () {
    return {
      breadcrumbs: [{
        text: 'Suggestions',
        to: { name: 'admin-suggestions' }
      },
      {
        text: 'View',
        active: true
      }]
    }
  },
  computed: {
    ...mapState('suggestions', {
      suggestion: 'current'
    })
  },
  methods: {
    suggestionImageSrc(image){
      if (image.thumbnail) {
        return image.thumbnail.url
      } else if(image) {
        return image.url
      } else {
        return ''
      }
    },
    readableDate,
    toUnixTime (date) {
      return moment(date).unix()
    },
    displayMedia (mediaID) {
      this.$store.dispatch('media/display', {
        tenantID: this.$route.params.organization,
        mediaID
      })
    },
    displayImage (image,show) {
      window.open(image.url)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/suggestions/view.vue